import { useContext, useEffect, useState } from "react";
import OnboardingBoilerplate from "./OnboardingBoilerplate";
import extractEventValue from "../../../../controllers/utils/extractEventValue";
import MaterialInput from "../../../helperComponents/MaterialInput";
import styled from "styled-components";
import { serverLine } from "../../../../controllers/network/serverLine";
import Context from "../../../../Context";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  width: 100%;
`;

export default function AskAddress({ asEditPage }) {
  const { loggedInUser, setLoggedInUser } = useContext(Context);
  const { t } = useTranslation();
  const [address, setAddress] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (loggedInUser) {
      setAddress(loggedInUser.address);
    }
  }, []);

  let title = "";

  if (loggedInUser.accountType == "NGO") {
    title = "Office Address";
  } else if (loggedInUser.accountType == "COMPANY") {
    title = "Office Address";
  }

  return (
    <OnboardingBoilerplate
      editPageTitle="Address"
      desc={"Please! type your office address"}
      asEditPage={asEditPage}
      skipID={"addressOnboardingSkipped"}
      title={title}
      onSubmit={onSubmit}
      loading={loading}
    >
      <Container>
        <MaterialInput
          label={"Address"}
          multiline={true}
          rows={10}
          value={address}
          onChange={extractEventValue(setAddress)}
        />
      </Container>
    </OnboardingBoilerplate>
  );

  async function onSubmit() {
    if (!address) return window.popupAlert("Please type the address");
    if (address.length < 20) return window.popupAlert("Address is too short");

    setLoading(true);

    try {
      await serverLine.patch("/me", {
        changes: { address },
      });
      setLoading(false);
      let newLoggedInUser = { ...loggedInUser, address };
      setLoggedInUser(newLoggedInUser);
      window.popupAlert(t("saved"));
    } catch (e) {
      window.popupAlert(e.message);
      setLoading(false);
    }
  }
}
